import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PatientService} from '../../services/patient.service';
import {UserService} from '../../services/user.service';
// Import wprost z pliku, nie z barrela: ModalService (eksportowany przez `../../services`)
// importuje ten komponent, więc przez barrel powstałby cykl zależności.
import {ConfirmationService} from '../../services/confirmation.service';

@Component({
  selector: 'app-form-questionnaire',
  templateUrl: './form-questionnaire.component.html',
  styleUrls: ['./form-questionnaire.component.scss']
})
export class FormQuestionnaireComponent implements OnInit {

    @Input()id: number;
    myForm: FormGroup;

  constructor(
      public activeModal: NgbActiveModal,
      private formBuilder: FormBuilder,
      private patientService: PatientService,
      private userService: UserService,
      private confirmation: ConfirmationService
  ) {
      this.createForm();
  }

  ngOnInit() {

  }

    closeModal() {
        this.activeModal.close('Modal Closed');
    }

    private createForm() {
        this.myForm = this.formBuilder.group({
            expection: '1',
            howoften: '1',
            is_ok: '1',
            more: ''
        });
    }
    submitForm() {
        this.activeModal.close(this.myForm.value);
    }

    sendForm() {
        this.confirmation.show('BACKEND.THANKING-FOR-FEEDBACK');
        this.patientService.questionnaireContact(this.myForm.get('expection').value, this.myForm.get('howoften').value,this.myForm.get('is_ok').value,this.myForm.get('more').value).subscribe(
            data => {
            },

        );
    }

}
